import React from 'react';
import { Card, Col } from 'antd';
import { MdLocationOn } from 'react-icons/md';
import { AiOutlineArrowRight, AiFillStar } from 'react-icons/ai';
import './styles.less';

const { Meta } = Card;

export const HotelCard = ({ img, title, description, id, url, city, country, rating = 0 }) => {

    return (
        <Col xs={24} md={12} xl={8}>
            <div
                onClick={() => { window.open(`/hotels/${country}/${city}/${title ? title.split(' ').join('-') + '-' : ''}${id}`, "_blank") }}
                target='_blank' rel='noreferrer noopener'
                className='text-decoration-none pointer'
            >
                <Card
                    style={{ width: '100%', borderRadius: '8px' }} hoverable
                    cover={
                        <div style={{ width: '100%', height: 300 }} className='d-flex justify-content-center align-items-center overflow-hidden'>
                            <img alt={title} src={img} style={{ objectFit: 'cover', objectPosition: 'center' }} className='h-100 w-100' loading='lazy' />
                        </div>
                    }
                    className="pointer h-100 hotel-card overflow-hidden"
                >
                    <Meta
                        title={title}
                        description={description}
                    />
                    <div className='mt-auto pt-1 d-flex flex-column'>
                        <div
                            className='d-flex flex-row align-items-center'
                        >
                            <MdLocationOn className='me-2' />
                            <p
                                className='mb-0'
                                style={{
                                    color: "#696969",
                                    fontSize: "16px",
                                    fontWeight: "400",
                                }}
                            >
                                {city}, {country}
                            </p>
                        </div>
                        <div
                            className='d-flex flex-row align-items-center justify-content-between flex-fill'
                        >
                            <div
                                className='d-flex flex-row align-items-center'
                            >
                                {
                                    [1, 2, 3, 4, 5].map((e, i) => (
                                        <AiFillStar key={i} className='me-1' style={{
                                            color: Math.ceil(rating - 0.51) >= e ? '#eb6957' : '#e4e5e9',
                                            fontSize: "16px",
                                        }} />
                                    ))
                                }
                            </div>
                            <div
                                className='d-flex flex-row align-items-center'
                            >
                                <p
                                    className='mb-0'
                                    style={{
                                        color: "#0081ff",
                                        fontSize: "16px",
                                        fontWeight: "700",
                                    }}
                                >
                                    More Details
                                </p>
                                <AiOutlineArrowRight className='ms-2' style={{
                                    color: "#0081ff",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                }} />
                            </div>

                        </div>
                    </div>
                </Card>
            </div>
        </Col>
    )
};
